(function () {
  'use strict';

  // The engraving card is rendered OUTSIDE the product <form>, so
  // card.closest('form') is always null. The form is resolved by id instead,
  // which comes from data-form-id on the card.
  function resolveForm(card) {
    var id = card.dataset.formId;
    if (id) {
      var byId = document.getElementById(id);
      if (byId) return byId;
    }
    return card.closest('form');
  }

  function initEngraving(card) {
    if (card.dataset.kgInit === '1') return;
    card.dataset.kgInit = '1';

    var header = card.querySelector('.kg-engraving-header');
    var body = card.querySelector('.kg-engraving-body');
    var input = card.querySelector('.kg-engraving-input');
    var fontField = card.querySelector('.kg-engraving-font-value');
    var counter = card.querySelector('.kg-engraving-counter');
    var preview = card.querySelector('.kg-engraving-preview__text');
    var radios = Array.prototype.slice.call(
      card.querySelectorAll('.kg-engraving-font-radio')
    );

    if (!input || !counter || !preview) return;

    var maxChars = parseInt(counter.dataset.max, 10) || 20;

    // Cache the original name attributes so they can be removed while the
    // field is empty and restored the moment it is filled again.
    [input, fontField].forEach(function (el) {
      if (el && !el.dataset.propName && el.getAttribute('name')) {
        el.dataset.propName = el.getAttribute('name');
      }
    });

    // Load the script font once per page.
    if (!document.getElementById('kg-dancing-script')) {
      var link = document.createElement('link');
      link.id = 'kg-dancing-script';
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;600&display=swap';
      document.head.appendChild(link);
    }

    if (header && body) {
      header.addEventListener('click', function () {
        var isOpen = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          body.classList.add('kg-engraving-body--closed');
        } else {
          body.classList.remove('kg-engraving-body--closed');
        }
      });
    }

    input.addEventListener('input', sync);
    radios.forEach(function (radio) {
      radio.addEventListener('change', sync);
    });

    // Run once so an empty field starts with its name removed.
    sync();

    function activeFont() {
      var checked = card.querySelector('.kg-engraving-font-radio:checked');
      if (checked) return checked;
      return radios[0] || null;
    }

    // Properties are only attached to the line item when the customer
    // actually typed something. An input with no name attribute is never
    // submitted, which is how blank properties are kept out of the order.
    function syncNames() {
      var filled = input.value.trim().length > 0;
      [input, fontField].forEach(function (el) {
        if (!el || !el.dataset.propName) return;
        if (filled) {
          el.setAttribute('name', el.dataset.propName);
        } else {
          el.removeAttribute('name');
        }
      });
    }

    function sync() {
      var len = input.value.length;
      counter.textContent = len + '/' + maxChars;

      if (len > maxChars) {
        counter.classList.add('kg-engraving-counter--over-limit');
        input.classList.add('kg-engraving-input--over-limit');
      } else {
        counter.classList.remove('kg-engraving-counter--over-limit');
        input.classList.remove('kg-engraving-input--over-limit');
      }

      var radio = activeFont();
      var fontFamily = radio
        ? radio.dataset.fontFamily
        : "'Cormorant Garamond', serif";

      if (fontField && radio) {
        fontField.value = radio.value;
      }

      preview.style.fontFamily = fontFamily;

      var text = input.value.trim();
      if (text) {
        preview.textContent = text;
        preview.dataset.empty = 'false';
        preview.style.fontStyle = '';
      } else {
        preview.textContent = preview.dataset.placeholder || '';
        preview.dataset.empty = 'true';
        preview.style.fontStyle = 'italic';
      }

      syncNames();
    }

    // Kept for debugging: confirms the card found its form.
    if (window.Shopify && window.Shopify.designMode && !resolveForm(card)) {
      console.warn('[kg-engraving] Ürün formu bulunamadı:', card.id);
    }
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[id^="kg-engraving-"]').forEach(function (card) {
      if (card.dataset.sectionId) {
        initEngraving(card);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor re-renders the section without reloading the page.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();